import { VacanciesTemplatesCreatePage } from '@pages/vacanciesTemplates';

export default VacanciesTemplatesCreatePage;
